import { Column, EndpointType, Filter } from '@nirvana/shared/dtos/types/shared/filters';
import { CommonThreatsNavigationHelper } from './common.threats.navigation.helper';
import { ActionTakenEnum, DetectingModules, DetectingTechnologies } from '@nirvana/shared/dtos/types/shared/threats';
import { OverviewNavigationFiltersParams } from '../navigation.interfaces';

export class OverviewNavigationHelper {
  public static getDisplayedColumns(): Array<Column> {
    return [
      Column.LAST_DETECTED,
      Column.ENDPOINT_TYPE,
      Column.DETECTING_MODULE,
      Column.DETECTING_TECHNOLOGY,
      Column.ACTION_TAKEN,
    ];
  }

  public static getFiltersForNavigationItem(params: OverviewNavigationFiltersParams): Array<Filter> {
    const filters = [
      CommonThreatsNavigationHelper.getLastDetectedOnFilterFromTimeRange(params.timeRange),
      CommonThreatsNavigationHelper.getCategoryFilter(),
      OverviewNavigationHelper.getActionsTakenFilter(),
      CommonThreatsNavigationHelper.getDeviceNameFilter(),
      OverviewNavigationHelper.getEndpointTypeFilter(params.notAvailableFeatures),
      OverviewNavigationHelper.getDetectingModuleFilter(),
      OverviewNavigationHelper.getDetectingTechnologyFilter(),
    ];

    return !params.isPartner ? filters : filters.concat(CommonThreatsNavigationHelper.getCompanyFilter(params.targets));
  }

  public static getActionsTakenValues(): Array<ActionTakenEnum> {
    return [
      ActionTakenEnum.DELETED,
      ActionTakenEnum.BLOCKED,
      ActionTakenEnum.QUARANTINED,
      ActionTakenEnum.REMEDIATED,
      ActionTakenEnum.MALICIOUS_PROCESS_KILLED,
      ActionTakenEnum.REPLACED_ATTACHMENT,
      ActionTakenEnum.DELETED_ATTACHMENT,
      ActionTakenEnum.REJECTED_EMAIL,
    ];
  }

  public static getEndpointTypeValues(notAvailableFeatures: string[] = []): Array<EndpointType> {
    const endpointTypes = [EndpointType.SERVER, EndpointType.WORKSTATION];
    if (notAvailableFeatures.length && !notAvailableFeatures.includes('containerProtectionUsable')) {
      endpointTypes.push(EndpointType.CONTAINER_HOST, EndpointType.CONTAINER);
    }

    return endpointTypes;
  }

  public static getDetectingModuleValues(): Array<DetectingModules> {
    return [
      DetectingModules.ANTIMALWARE,
      DetectingModules.NETWORK_PROTECTION,
      DetectingModules.STORAGE_PROTECTION,
      DetectingModules.EXCHANGE_PROTECTION,
    ];
  }

  public static getDetectingTechnologyValues(): Array<DetectingTechnologies> {
    return [
      DetectingTechnologies.ANTIMALWARE_ON_ACCESS,
      DetectingTechnologies.ANTIMALWARE_ON_DEMAND,
      DetectingTechnologies.ANTIMALWARE_ON_DEMAND_SCHEDULED_SCANS,
      DetectingTechnologies.ANTIMALWARE_CONTEXTUAL_SCAN,
      DetectingTechnologies.ANTIMALWARE_AVC,
      DetectingTechnologies.ANTIMALWARE_HYPER_DETECT,
      DetectingTechnologies.ANTIMALWARE_ON_EXECUTE_FILELESS_ATTACK_PROTECTION,
      DetectingTechnologies.ANTIMALWARE_ON_EXECUTE_ATC,
      DetectingTechnologies.ANTIMALWARE_ADVANCED_ANTI_EXPLOIT,
      DetectingTechnologies.NETWORK_PROTECTION_WEB_PROTECTION_WEB_TRAFFIC_SCAN,
      DetectingTechnologies.NETWORK_PROTECTION_WEB_PROTECTION_ANTIPHISING,
      DetectingTechnologies.NETWORK_PROTECTION_WEB_PROTECTION_HYPER_DETECT,
      DetectingTechnologies.NETWORK_PROTECTION_NETWORK_ATTACK_DEFENSE,
      DetectingTechnologies.STORAGE_PROTECTION_STORAGE_PROTECTION,
      DetectingTechnologies.EXCHANGE_PROTECTION_ANTIMALWARE,
    ];
  }

  private static getActionsTakenFilter(): Filter {
    return {
      actionTaken: {
        in: OverviewNavigationHelper.getActionsTakenValues(),
      },
    };
  }

  private static getEndpointTypeFilter(notAvailableFeatures: string[] = []): Filter {
    return {
      endpointType: {
        in: OverviewNavigationHelper.getEndpointTypeValues(notAvailableFeatures),
      },
    };
  }

  private static getDetectingModuleFilter(): Filter {
    return {
      detectingModule: {
        in: OverviewNavigationHelper.getDetectingModuleValues(),
      },
    };
  }

  private static getDetectingTechnologyFilter(): Filter {
    return {
      detectingTechnology: {
        in: OverviewNavigationHelper.getDetectingTechnologyValues(),
      },
    };
  }
}
